<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">المدفوعات</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">المدفوعات</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div v-if="checkAccess('payments_create')" class="row mt-4">
        <div class="col text-end">
          <router-link to="/payments/create" class="btn btn-primary">
            <i class="bi bi-plus-circle me-1"></i> تعديل رصيد عميل
          </router-link>
        </div>
      </div>
      <!--FILTER-->
      <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="رقم جوال العميل">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchDescription" class="form-control" placeholder="الوصف">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchApproved">
                      <option :value="null">حالة القبول</option>
                      <option value="true">مقبول</option>
                      <option value="false">غير مقبول</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchTransactionType" aria-label="نوع العملية">
                      <option :value="null">نوع العملية</option>
                      <option value="plus">إضافة</option>
                      <option value="minus">خصم</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div>
                  <button type="button" class="btn btn-success btn-sm" @click="exportExcel" :disabled="!hasActiveFilter"><i class="fa fa-file-excel"></i> تصدير Excel</button>
                </div>
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">المدفوعات</div>
                  <span v-if="countRows > 0"
                    class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                    عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>الاسم</th>
                            <th>رقم الجوال</th>
                            <th>الوصف</th>
                            <th>القيمة</th>
                            <th>نوع العملية</th>
                            <th>مقبول</th>
                            <th>الحالة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ (row.User)? row.User.name : 'غير معروف' }}</td>
                            <td>{{ (row.User)? row.User.mobile : '—' }}</td>
                            <td>{{ row.description }}</td>
                            <td>{{ row.amount }}</td>
                            <td>{{ transactionTypeLabel(row.transactionType) }}</td>
                            <td>{{ (row.approved)? 'نعم' : 'لا' }}</td>
                            <td>{{ row.status }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/payments/update/${row.id}`" class="btn btn-light btn-sm me-3"><i class="fa-regular fa-eye"></i></router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'Payments',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      statusTranslate: {},
      searchName: this.$route.query.name || '',
      searchMobile: this.$route.query.mobile || '',
      searchDescription: this.$route.query.description || '',
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      searchApproved: this.$route.query.approved || null, 
      showDateFilter: false,
      searchTransactionType: ['plus', 'minus'].includes(this.$route.query.transactionType) ? this.$route.query.transactionType : null,
      countRows: 0,
    }
  },
  computed: {
    hasActiveFilter() {
      return (
        this.searchName.trim() !== '' ||
        this.searchMobile.trim() !== '' ||
        this.searchDescription.trim() !== '' ||
        this.searchApproved !== null ||
        this.searchTransactionType !== null ||
        this.searchDateFrom !== null ||
        this.searchDateTo !== null
      );
    }
  },
  methods: {
    checkAccess,
    transactionTypeLabel(transactionType) {
      if (transactionType === 'plus') return 'إضافة';
      if (transactionType === 'minus') return 'خصم';
      return '—';
    },
    getList(){
      this.mainLoading = true;
      let urlQuery = [`page=${this.currentPage}`];

      if (this.searchName.trim() !== '')
        urlQuery.push(`name=${encodeURIComponent(this.searchName.trim())}`);

      if (this.searchMobile.trim() !== '')
        urlQuery.push(`mobile=${encodeURIComponent(this.searchMobile.trim())}`);

      if (this.searchDescription.trim() !== '')
        urlQuery.push(`description=${this.searchDescription.trim()}`);
      
      if (this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
    
      if (this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);
  
      if (this.searchApproved !== null)
        urlQuery.push(`approved=${this.searchApproved}`);

      if (this.searchTransactionType)
        urlQuery.push(`transactionType=${this.searchTransactionType}`);
  
      this.hasError = false;

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName !== null && this.searchName !== '' && this.searchName !== false ? { name: this.searchName } : {}),
        ...(this.searchMobile !== null && this.searchMobile !== '' && this.searchMobile !== false ? { mobile: this.searchMobile } : {}),
        ...(this.searchDescription !== null && this.searchDescription !== '' && this.searchDescription !== false ? { description: this.searchDescription } : {}),
        ...(this.searchDateFrom !== null && this.searchDateFrom !== '' && this.searchDateFrom !== false ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo !== null && this.searchDateTo !== '' && this.searchDateTo !== false ? { dateTo: this.searchDateTo } : {}),
        ...(this.searchApproved !== null && this.searchApproved !== '' && this.searchApproved !== false ? { approved: this.searchApproved } : {}),
        ...(this.searchTransactionType ? { transactionType: this.searchTransactionType } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/payments/list?${urlQuery.join('&')}`)
        .then(({data}) => {
          this.rows = data.rows;
          this.statusTranslate = data.statusChioces;
          this.pages = data.pages ?? [this.currentPage];
          this.countRows = data.countRows ?? 0;
          this.mainLoading = false;
        })
        .catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchMobile = '';
      this.searchDescription = '';
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.searchApproved = null;
      this.searchTransactionType = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    async exportExcel() {
      let urlQuery = [];

      if (this.searchName)
        urlQuery.push(`name=${encodeURIComponent(this.searchName)}`);
      if (this.searchMobile)
        urlQuery.push(`mobile=${encodeURIComponent(this.searchMobile)}`);
      if (this.searchDescription)
        urlQuery.push(`description=${this.searchDescription}`);
      if (this.searchApproved !== null)
        urlQuery.push(`approved=${this.searchApproved}`);
      if (this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if (this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);
      if (this.searchTransactionType)
        urlQuery.push(`transactionType=${this.searchTransactionType}`);

      const url = `/api/admin/payments/export?${urlQuery.join('&')}`;

      try {
        const response = await this.$http.get(url, { responseType: 'blob' }); 
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'payments.xlsx';
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        toast('فشل تصدير الملف', 'error');
      }
    },
  },
  created(){
    this.getList();
  }
}
</script>